import * as React from 'react';
import { GlobalPrivateState } from 'src/api';
import { connect } from 'react-redux';
import { ConfigurationModel, CartModel } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './checkout.messages';

export interface  TroughPartialCheckoutProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
}

export class TroughPartialCheckout extends React.Component<TroughPartialCheckoutProps, any> {
  public render() {
    return (
      <div className="trough-partial-line">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.troughCheckoutHeadline} />
        </span>
        <div className="trough-partial-line">
          <ul>
            {this.checkout && this.checkout.lines && this.checkout.lines.selectedTrough && (
              <>
                <li><FormattedMessage {...MESSAGES.troughCheckoutName} /> {this.checkout.lines.selectedTrough[0].part.name}</li>
                <li><FormattedMessage {...MESSAGES.troughCheckoutQty} /> {this.checkout.lines.selectedTrough[0].qty}</li>
              </>
            )}
            {this.configuration && this.configuration.selectedTrough && this.configuration.selectedTrough.trough && (
              <>
                <li>
                  <FormattedMessage {...MESSAGES.troughCheckoutDimensions} /> &nbsp;
                  {this.configuration.selectedTrough.trough.throughWidth} mm x {this.configuration.selectedTrough.trough.throughHeight} mm x {this.configuration.selectedTrough.trough.throughDepth} mm
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }

  private get checkout(): CartModel |undefined {
    const { checkout } = this.props;
    return checkout && checkout.result;
  }
}

export const TroughPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(TroughPartialCheckout);

export default TroughPartialCheckoutComponent;